import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const CancelInvoiceModal = ({ open, onClose, onConfirm }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      <div className="relative z-10 bg-white rounded-xl shadow-2xl p-6 w-full max-w-md mx-4">
        <div className="flex items-center justify-center w-14 h-14 mx-auto mb-4 rounded-full bg-orange-100">
          <WarningAmberIcon sx={{ fontSize: 28, color: "#f97316" }} />
        </div>

        <h2 className="text-center text-lg font-bold text-gray-800 mb-2">
          Cancel Invoice Confirmation
        </h2>

        <p className="text-center text-gray-600 text-sm mb-3">
          Have you already cancelled this invoice from the{" "}
          <span className="font-semibold text-orange-600">
            FBR Portal (IRIS.com)
          </span>
          ?
        </p>

        <p className="text-center text-gray-500 text-xs mb-6 bg-orange-50 border border-orange-200 rounded-lg p-3">
          Confirming here is an acknowledgment that you have already performed
          the cancellation on the FBR Portal. This action cannot be undone.
        </p>

        <div className="flex gap-3">
          <button
            onClick={onConfirm}
            className="flex-1 bg-red-600 hover:bg-red-700 active:bg-red-800 text-white font-semibold py-2.5 px-4 rounded-lg transition-colors duration-150"
          >
            Yes
          </button>
          <button
            onClick={onClose}
            className="flex-1 bg-gray-100 hover:bg-gray-200 active:bg-gray-300 text-gray-700 font-semibold py-2.5 px-4 rounded-lg transition-colors duration-150"
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelInvoiceModal;
